// src/pages/ResetPassword.jsx
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../services/api';
import AuthShell, { IconEye, IconArrow, IconBack } from '../components/auth/AuthShell';


export default function ResetPassword() {
    const [searchParams]  = useSearchParams();
    const navigate        = useNavigate();
    const token           = searchParams.get('token');

    const [newPassword,     setNewPassword]     = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPass,        setShowPass]        = useState(false);
    const [loading,         setLoading]         = useState(false);

    useEffect(() => {
        if (!token) navigate('/login', { replace: true });
    }, [token, navigate]);

    const handleSubmit = async e => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            toast.error('Las contraseñas no coinciden', { autoClose: 3000 });
            return;
        }
        setLoading(true);
        try {
            await api.post('/auth/reset-password', { token, newPassword });
            toast.success('Contraseña actualizada. Ahora puedes iniciar sesión.', { autoClose: 3000 });
            navigate('/login', { replace: true });
        } catch (err) {
            toast.error(err.response?.data?.error || 'Token inválido o expirado', { autoClose: 4000 });
        } finally {
            setLoading(false);
        }
    };

    if (!token) return null;

    return (
        <AuthShell>
            <h1 className="auth-title">Nueva contraseña</h1>
            <p className="auth-subtitle">
                Elige una contraseña segura para tu cuenta.
            </p>

            <form onSubmit={handleSubmit}>
                <div className="auth-field">
                    <label className="auth-label" htmlFor="rp-new">Nueva contraseña</label>
                    <div className="auth-input-wrap">
                        <input
                            id="rp-new"
                            type={showPass ? 'text' : 'password'}
                            className="auth-input has-toggle"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                            placeholder="Mínimo 6 caracteres"
                            required minLength={6} autoFocus autoComplete="new-password"
                        />
                        <button
                            type="button"
                            className="auth-toggle"
                            onClick={() => setShowPass(v => !v)}
                            tabIndex={-1}
                            aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            <IconEye off={showPass} />
                        </button>
                    </div>
                </div>

                <div className="auth-field">
                    <label className="auth-label" htmlFor="rp-confirm">Confirmar contraseña</label>
                    <input
                        id="rp-confirm"
                        type={showPass ? 'text' : 'password'}
                        className="auth-input"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        placeholder="Repite la contraseña"
                        required minLength={6} autoComplete="new-password"
                    />
                </div>

                <button type="submit" className="auth-submit" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : <>Establecer contraseña <IconArrow /></>}
                </button>
            </form>

            <div className="auth-footer-link">
                <Link to="/login">
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        <IconBack /> Volver al inicio de sesión
                    </span>
                </Link>
            </div>
        </AuthShell>
    );
}
